import { InvoiceVisual, ChartVisual, LockVisual } from "./ProblemSection.visuals";

export type Problem = { title: string; body: string; visual: React.ReactNode };

export const problems: Problem[] = [
  {
    title: "Overcharged & underdelivered",
    body:
      "Most agencies charge $5,000–$10,000+ upfront for a template website they built in a day. You deserve better.",
    visual: <InvoiceVisual />,
  },
  {
    title: "Websites that don't convert",
    body:
      "A pretty website means nothing if it doesn't turn visitors into paying customers. Most designers don't understand business.",
    visual: <ChartVisual />,
  },
  {
    title: "Held hostage by your developer",
    body:
      "Need a small change? That'll be $150 and a 2-week wait. The old model is broken — and they know it.",
    visual: <LockVisual />,
  },
];
